import $ from 'jquery';
import Alert from "./ComponentAlerts";

function getTrainingDates(month, year, callbackSuccess, callbackError) {
    $.ajax({
        url: '/api/training/dates/' + month + '/' + year,
        dataType: 'json'
    }).done(function (data) {
        if (data.status === 200) {
            if (typeof callbackSuccess === 'function') {
                callbackSuccess(data);
            }
        } else {
            Alert.show(data.error[0], 'danger');
            if (typeof callbackError === 'function') {
                callbackError(data);
            }
        }
    });
}

function generateDayList(dayLimit, currentDay, highlights = [], startDateStr = null) {
    currentDay = currentDay || -1;

    const weekdays = ['S', 'M', 'T', 'W', 'T', 'F', 'S'];

    const startDate = startDateStr ? new Date(startDateStr) : new Date();

    console.log('SD', startDate);

    const container = $('<ul></ul>').addClass('pagination day-selector');

    for (let i = 0; i < dayLimit; i++) {
        const dayNum = i + 1;

        const date = new Date(startDate);
        date.setDate(startDate.getDate() + i);

        const weekdayLabel = weekdays[date.getDay()];

        const isActive = currentDay === dayNum;
        const isHighlighted = highlights?.map(h => parseInt(h)).includes(dayNum);

        const link = $('<a></a>')
            .addClass('page-link')
            .toggleClass('pagination-highlight', isHighlighted)
            .attr('href', '#change-day')
            .attr('data-event', 'select-day')
            .attr('data-value', dayNum)
            .html(`
                <div class="day-content">
                    <div class="weekday">${weekdayLabel}</div>
                    <div class="day-number">${dayNum}</div>
                </div>
            `);

        const item = $('<li></li>')
            .addClass('page-item')
            .toggleClass('active', isActive)
            .append(link);

        container.append(item);
    }

    return $('<nav></nav>').append(container);
}

function prepareForm() {
    $('form[name="training_search_form"]')
        .attr('data-year', parseInt($('#training_search_form_year').val()))
        .attr('data-month', parseInt($('#training_search_form_month').val()))
        .attr('data-day', parseInt($('#training_search_form_day').val()))
}

$(function () {
    $(document).on('change', '*[data-event="change-date"]', function () {
        const $form = $('form[name="training_search_form"]');

        const month = parseInt($form.data('month'));
        const year = parseInt($form.data('year'));
        const day = parseInt($form.data('day'));
        const selectedMonth = parseInt($('#training_search_form_month').val());
        const selectedYear = parseInt($('#training_search_form_year').val());
        const selectedDay = (month === selectedMonth && year === selectedYear) ? day : -1;

        getTrainingDates(selectedMonth, selectedYear, function (data) {
            const daysCount = new Date(selectedYear, selectedMonth, 0).getDate();

            $('#day-navigator').html(
                generateDayList(
                    daysCount,
                    selectedDay,
                    data.data,
                    new Date(selectedYear, selectedMonth - 1, 1).toISOString()
                )
            );
        });
    });

    $(document).on('click', '*[data-event="select-day"]', function () {
        $('#training_search_form_day').val(
            parseInt($(this).data('value'))
        );

        $('form[name="training_search_form"]').submit();

        return false;
    });

    $(document).ready(function () {
        prepareForm();
        $('#training_search_form_year').change();
    });
});